import type { Root } from 'mdast';
import type { VFile } from 'vfile';
import { visit } from 'unist-util-visit';

import { IFRAME_MDX_DIRECTIVE_NAME } from './iframeMdxDirectiveConstants';

export const iframeMdxDirectiveRemarkPlugin =
  () =>
  (tree: Root, file: VFile): void => {
    visit(tree, function (node) {
      if (node.type === 'leafDirective') {
        if (node.name !== IFRAME_MDX_DIRECTIVE_NAME) {
          return;
        }

        // eslint-disable-next-line no-param-reassign
        const data = node.data ?? (node.data = {});
        const attributes = node.attributes ?? {};
        const url = attributes.url;

        if (!url) {
          file.fail(
            `Unexpected missing \`url\` on \`${IFRAME_MDX_DIRECTIVE_NAME}\` directive.`,
            node,
          );
        }

        data.hName = 'iframe';
        data.hProperties = {
          src: url,
          title: 'Embedded page',
          class: 'crowdaa-article-iframe',
        };
      }
    });
  };
